// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"f5d0947e","772":"152de451","847":"93086e1d","997":"b1c81d19"}[chunkId] + ".chunk.js";
};